import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { getEffectiveAccessibleModules } from '@/lib/moduleRegistry';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

const ModuleSwitcher = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const modules = getEffectiveAccessibleModules(user);
  if (modules.length < 2) return null;
  const current = modules.find((module) => location.pathname === module.homeRoute || location.pathname.startsWith(`${module.homeRoute}/`));

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm hover:bg-slate-50" aria-label="Wissel van omgeving">
          {current?.label || 'Mijn omgevingen'} <ChevronDown className="h-4 w-4 text-slate-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <p className="px-2 py-1.5 text-xs font-semibold uppercase tracking-wide text-slate-400">Mijn omgevingen</p>
        {modules.map((module) => {
          const Icon = module.icon;
          return <DropdownMenuItem key={module.id} onClick={() => navigate(module.homeRoute)}><Icon className="mr-2 h-4 w-4" />{module.label}</DropdownMenuItem>;
        })}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate('/dashboard')}>Zoea overzicht</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ModuleSwitcher;
